import { useState } from "react";
import { CheckCircle2, Sparkles } from "lucide-react";

const QuickWriteActivity = ({ activity, completed, completion, onComplete, busy }) => {
  const data = activity?.data || {};
  const [text, setText] = useState("");

  const submit = () => {
    if (text.trim().length < 5) return;
    onComplete(text.trim());
  };

  return (
    <div data-testid={`activity-quickwrite-${activity.title}`}>
      <div className="rounded-2xl bg-mm-parchment border-2 border-mm-navy/10 p-5">
        <div className="text-xs uppercase tracking-widest font-bold text-mm-steel">Prompt</div>
        <p className="mt-2 font-heading text-lg font-bold text-mm-navy leading-snug">{data.prompt}</p>
      </div>

      {!completed ? (
        <>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Type your answer..."
            rows={5}
            className="mt-4 w-full bg-white border-2 border-mm-navy/15 rounded-lg px-4 py-3 focus:outline-none focus:border-mm-steel focus:ring-2 focus:ring-mm-steel/30 font-body"
            data-testid="quickwrite-textarea"
          />
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs text-mm-navy/60">{text.trim().length} characters</span>
            <span className="text-xs text-mm-steel font-bold uppercase tracking-widest">AI-graded for feedback</span>
          </div>
          <button
            onClick={submit}
            disabled={text.trim().length < 5 || busy}
            className="btn-trail btn-gold w-full mt-4 disabled:opacity-50"
            data-testid="quickwrite-submit"
          >
            {busy ? "Trail guide reviewing..." : (<><Sparkles size={16} strokeWidth={2.5} /> Submit & earn +15 AP</>)}
          </button>
        </>
      ) : (
        <div className="mt-4 space-y-3">
          <div className="rounded-2xl bg-white border-2 border-mm-steel/30 p-5">
            <div className="text-xs uppercase tracking-widest font-bold text-mm-steel">Your response</div>
            <p className="mt-2 text-mm-navy whitespace-pre-wrap">{completion?.response || ""}</p>
          </div>
          {completion?.feedback && (
            <div className="rounded-2xl bg-mm-gold/15 border-2 border-mm-gold/50 p-5">
              <div className="text-xs uppercase tracking-widest font-bold text-mm-gold">Trail guide feedback {completion?.score != null ? `• ${completion.score}/100` : ""}</div>
              <p className="mt-2 text-mm-navy">{completion.feedback}</p>
            </div>
          )}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-mm-steel/15 text-mm-navy rounded-full font-bold">
            <CheckCircle2 size={16} strokeWidth={2.5} /> Trail marker planted · +15 AP
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickWriteActivity;
